var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.9707 22.75h-6c-5.43 0-7.75-2.32-7.75-7.75v-6c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.31 7.75-7.75 7.75zm-6-20c-4.61 0-6.25 1.64-6.25 6.25v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-6c0-4.61-1.64-6.25-6.25-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.9707 22.75c-.41 0-.75-.34-.75-.75v-20c0-.41.34-.75.75-.75s.75.34.75.75v20c0 .41-.33.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.9696 15.3099c-.19 0-.38-.07-.53-.22l-2.56-2.56c-.29-.29-.29-.77 0-1.06l2.56-2.56002c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-2.02 2.03002 2.03 2.03c.29.29.29.77 0 1.06-.15.15-.34.22-.54.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuControl);
export default __webpack_public_path__ + "static/media/menu-control.f56c142ed269442c857dd0faa67e1972.svg";
export { ForwardRef as ReactComponent };